import { createSelector } from "reselect"
import { get, compact } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeDatasetEntitlementsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"

const getRawMemberPermissions = (_, props) => get(props, "memberPermissions.member.resourcePermissions")
const getRawResources = (_, props) => get(props, "resources.resources")

export const getResources = createSelector(
  [getRawResources],
  (rawResources) => compact(rawResources),
)

export const getMemberPermissions = createSelector(
  [getRawMemberPermissions],
  (rawMemberPermissions) => compact(rawMemberPermissions),
)

export const getTabs = createSelector(
  [getRoute, getPath, getIsOpPro],
  computeDatasetEntitlementsTabs,
)
